module.exports = __webpack_public_path__ + "static/media/3RI_channel.00f789ea.png";